module.exports = __webpack_public_path__ + "static/img/10.c53f417.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/99/zh/10.png
// module id = Pm4X
// module chunks = 0